export const Keys: { [key: string]: string[] } = {
    Z: ['Z', 'z', 'я', 'Я'],
    Q: ['Q', 'q', 'й', 'Й'],
    W: ['W', 'w', 'ц', 'Ц'],
    E: ['E', 'e', 'у', 'У'],
    R: ['R', 'r', 'к', 'К'],
    D: ['D', 'd', 'в', 'В'],
    A: ['A', 'a', 'ф', 'Ф'],
    J: ['J', 'j', 'о', 'О'],
    E1: ['E', 'e', 'у', 'У'],
}
